export const NEO_CHK = 'NEO_CHK';
export const ACCEPT_MATURE = 'AcceptMature';
